import React from 'react';
import { ServicesContext } from '~/services';
import { formatUserName } from '~/util';

export function StaticBasicInfo() {
    const servicesContext = React.useContext(ServicesContext);
    const user = servicesContext.user.get();

    return (
        <>
            <div className="row">
                <div className="col-3 text-end">Full Name</div>
                <div className="col-9">{formatUserName(user, true)}</div>
            </div>
            <div className="row">
                <div className="col-3 text-end">Title</div>
                <div className="col-9">{user.title}</div>
            </div>
            <div className="row">
                <div className="col-3 text-end">MSID</div>
                <div className="col-9">{user.msid || 'None'}</div>
            </div>
        </>
    );
}
